import { EMPTY_RESULTS_WEB_COMPONENT } from '@components/EmptyResultsComponent/CONSTANTS';
import { EMPTY_RESULTS_ATTRIBUTE } from '@core/constants/ATTRIBUTES';

/**
 * Show the empty results.
 * @param {ShadowRoot} shadowRoot - The shadow root.
 * @param {string} querySelectorName - The query selector name.
 * @returns {void}
 */
export const showEmptyResults = (shadowRoot, querySelectorName) => {
    /** @type {HTMLElement} */
    const container = shadowRoot.querySelector(querySelectorName);
    /** @type {HTMLElement} */
    const emptyResults = document.createElement(EMPTY_RESULTS_WEB_COMPONENT);
    emptyResults.setAttribute(EMPTY_RESULTS_ATTRIBUTE, '');

    container.innerHTML = '';
    container.appendChild(emptyResults);
};
